// Legacy image srcs (Firebase adapter) appended `&scale=` onto a download
// URL that already carried its own query string, so `new URL(src)` parses
// them fine. But `useRichTextImages`/`useImagesEdit` historically ran
// `new URLSearchParams(image.src)` directly, which also "works" (in a
// loose sense) on non-absolute / malformed strings by treating the whole
// string as a query. Keep that fallback so any src that isn't a valid
// absolute URL still parses exactly like the old code did.
export const getScaleFromSrc = (src: string): string | null => {
  try {
    return new URL(src).searchParams.get("scale");
  } catch {
    return new URLSearchParams(src).get("scale");
  }
};
